const locale = {
  SKILL_INSIGHTS: 'Análisis de Brechas',
  STUDENT_OVERVIEW: 'Resumen de Estudiantes',
  STUDENT_ADVISING: 'Mentoría Profesional',
  COURSE_RECOMMENDATIONS: 'Recomendaciones de Cursos',
  CAREER_TRENDS: 'Tendencias Profesionales',
  CONTACT_US: 'Contáctanos',
  FAQ: 'Preguntas Frecuentes',
  GENERAL: 'General',
  SUPPORT: 'Soporte',
  NAV_ARIA_LABEL: 'Navegación de Advisor',
};

export default locale;
